import { useState } from "react";

import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { useContext } from "react";
import { UserContext } from "../contexts/AuthContext";
import classes from "./Login.module.css";
import { ToastContainer, toast } from 'react-toastify';

const apiUrl = process.env.REACT_APP_API_URL;

const LoginPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const userContext = useContext(UserContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleLogin = async (data: any) => {
    setIsLoading(true);
    const response = await fetch(`${apiUrl}/admin/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      redirect: "follow",
      body: JSON.stringify(data),
    });
    const res = await response.json();
    if (res.success) {
      userContext.login(res.token);
      // userContext.token = res.token;
      // userContext.isAuthenticated = true;
      localStorage.setItem("token", res.token);
      toast.success("Logged in successfully");
      navigate("/dashboard");
    } else {
      console.log(res.error)
      toast.error("Error, please try again");
      //alert(res.error || "Login failed");
    }
    setIsLoading(false);
  };
  const onFormSubmitHandler = (data: any) => {
    console.log("Form Submitted", data);
    handleLogin(data);
  };
  return (
    <div className={`container ${classes["login-wrapper"]}`}>
      <ToastContainer></ToastContainer>
      <div className="row justify-content-center">
        <div className={`col-12 col-md-4`}>
          <p className={`text-center ${classes["loginTitle"]}`}>Login to JTS Dashboard</p>
          <form
            onSubmit={handleSubmit(onFormSubmitHandler)}
            className={classes["form-container"]}
          >
            <div className={`form-group ${classes["fileds-gap"]}`}>
              <label htmlFor="username">Username</label>
              <input
                type="text"
                className="form-control"
                id="username"
                placeholder="Enter username"
                {...register("username", {
                  required: "User name is required",
                })}
              />
              {errors.username && (
                <p style={{ color: "red" }}>User name is required</p>
              )}
            </div>
            <div className={`form-group ${classes["fileds-gap"]}`}>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="Password"
                {...register("password", {
                  required: "Password is required",
                })}
              />
              {errors.password && (
                <p style={{ color: "red" }}>Password is required</p>
              )}
            </div>
            <div className={`d-grid gap-2 ${classes["fileds-gap"]}`}>
              <button className={`btn btn-primary ${classes["submitButton"]}`} type="submit">
                {isLoading ? 'Logging in ...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
